import LabelPreview from "./LabelPreview";

export default function LabelPreviewSection({
  styles,
  activeTab,
  activePreviewId,
  forms,
  pharmacyInfo,
  drugInfo,
  user,
  receiptNumber,
  handleDrugInfoUpdate,
  effectiveShowRepeat,
  repeatData,
  repeatNumberFromNav,
  setActivePreviewId,
}) {
  const showPopupPreview =
    activeTab === "Item Label" &&
    activePreviewId !== null &&
    forms.length > 1;

  const showInlinePreview =
    activeTab === "Item Label" &&
    activePreviewId !== null &&
    forms.length < 2;

  const showTracerPreview = activeTab === "Tracer Label" && forms.length > 0;

  if (showPopupPreview) {
    const previewForm = forms.find((f) => f.id === activePreviewId);

    return (
      <div className={styles.previewPopup}>
        <LabelPreview
          form={previewForm}
          pharmacyInfo={pharmacyInfo}
          activeTab={activeTab}
          drugInfo={drugInfo}
          user={user}
          onClose={() => setActivePreviewId(null)}
          showClose={true}
          showWrapper={true}
          receiptNumber={receiptNumber}
          onDrugInfoUpdate={handleDrugInfoUpdate}
          showRepeat={effectiveShowRepeat}
          repeatData={repeatData}
          repeatNumber={repeatNumberFromNav}
        />
      </div>
    );
  }

  if (showInlinePreview) {
    const previewForm = forms.find((f) => f.id === activePreviewId);

    return (
      <LabelPreview
        form={previewForm}
        pharmacyInfo={pharmacyInfo}
        activeTab={activeTab}
        drugInfo={drugInfo}
        showWrapper={true}
        receiptNumber={receiptNumber}
        user={user}
        onDrugInfoUpdate={handleDrugInfoUpdate}
        showRepeat={effectiveShowRepeat}
        repeatData={repeatData}
        repeatNumber={repeatNumberFromNav}
      />
    );
  }

  if (showTracerPreview) {
    return (
      <LabelPreview
        form={forms[0]}
        forms={forms}
        pharmacyInfo={pharmacyInfo}
        activeTab={activeTab}
        drugInfo={drugInfo}
        showWrapper={true}
        receiptNumber={receiptNumber}
        user={user}
        onDrugInfoUpdate={handleDrugInfoUpdate}
        showRepeat={effectiveShowRepeat}
        repeatData={repeatData}
        repeatNumber={repeatNumberFromNav}
      />
    );
  }

  return null;
}
